import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import NotActive from "../assets/Not-Active.png";
import { Link } from "react-router-dom";
const ComponentSearch = ({ selectedLetter }) => {
  const [components, setComponents] = useState([]);
  const [expandedIds, setExpandedIds] = useState(new Set());

  const fetchComponents = useCallback(() => {
    const queryParameters = {
      params: {
        letter: selectedLetter || "",
      },
    };

    console.log("Fetching components with:", selectedLetter);
    axios
      .get(`${process.env.REACT_APP_API_URL}/companies/componentsearch`, queryParameters)
      .then((response) => {
        console.log("Components fetched successfully:", response.data);
        setComponents(response.data);
      })
      .catch((error) => {
        console.error("Failed to fetch components:", error);
      });
  }, [selectedLetter]);

  useEffect(() => {
    fetchComponents();
  }, [fetchComponents]);

  const toggleExpand = (id) => {
    const newSet = new Set(expandedIds);
    if (newSet.has(id)) {
      newSet.delete(id);
    } else {
      newSet.add(id);
    }
    setExpandedIds(newSet);
  };

  return (
    <div>
      <h2>Component Search</h2>
      <div className="terms-list">
        {components.map((component) => (
          <div
            key={component.id}
            className={`term-entry ${expandedIds.has(component.id) ? "open" : ""}`}
            onClick={() => toggleExpand(component.id)}
          >
            <h2 className="term-title"
              style={{ cursor: "pointer", position: "relative" }}
            >
              <span className="expand-toggle">
                {expandedIds.has(component.id) ? (
                  <span><i className="fa-solid fa-circle-chevron-up"></i></span>
                ) : (
                  <span><i className="fa-solid fa-circle-chevron-right"></i></span>
                )}
              </span>
              {component.name_en}
            </h2>
            {expandedIds.has(component.id) && (
              <div className="term-content" style={{ position: "relative" }}>
              {component.me_about && <p>{component.me_about}</p>}
              <i className="fas fa-home"></i> &nbsp;
              <Link to={`/companies/${component.id}#/companies/${component.id}`}
                style={{ color: "inherit", textDecoration: "none" }}
              >
                My eDMAC Company Page
              </Link>
              {component.is_active === 0 && (
                <img
                  src={NotActive}
                  alt="Not Active Icon"
                  style={{
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    width: 60,
                  }}
                />
              )}
            </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComponentSearch;
